export default __webpack_public_path__ + "static/media/detail_banner_ad.b0b78ab5.png";